import { render } from "./tariff_book_rates_modal.html?vue&type=template&id=19341f8a&external"
import script from "./tariff_book_rates_modal.js?vue&type=script&lang=js&external"
export * from "./tariff_book_rates_modal.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__